<template>
  <div class='lt-scene-transport'>
    <Transition name='lt-bus-stop'>
      <img
        src="../../assets/transport-1-stop.svg"
        class="lt-scene-transport_stop"
        v-show="transport === 1"
        alt=""
      />
    </Transition>


    <Transition name='lt-drive-in'>
      <img
        src="../../assets/transport-1.svg"
        class="lt-scene-transport_1"
        v-show="transport === 1"
        alt=""
      />
    </Transition>

    <Transition name='lt-drive-in'>
      <img
        src="../../assets/transport-2.svg"
        class="lt-scene-transport_2"
        v-show="transport === 2"
        alt=""
      />
    </Transition>

    <Transition name='lt-drive-in'>
      <img
        src="../../assets/transport-3.svg"
        class="lt-scene-transport_3"
        v-show="transport === 3"
        alt=""
      />
    </Transition>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      'scene.status.transport',
    ]),
  },
};
</script>


